import {
	getTopNavBottomPosition,
	subscribeToTopNavBottomPosition,
	unsubscribeFromTopNavBottomPosition,
} from '@apps/www/src/www/helpers/topNavBottomPositionEmitter';
import useElementBoudingClientRectUpdated from '@apps/www/src/www/hooks/useElementBoudingClientRectUpdated';
import useEventCallback from '@pkgs/shared-client/hooks/useEventCallback';
import { useEffect, useRef } from 'react';

// This dynamically leaves a top space to compensate for the top nav bar whenever it opens in any
// scroll position.
const SVTopNavSpacer = ({ containerRef }: { containerRef: React.RefObject<HTMLDivElement> }) => {
	const spacerRef = useRef<HTMLDivElement>(null);
	const topNavBottomPositionRef = useRef<number>(getTopNavBottomPosition());

	const update = useEventCallback(() => {
		if (!spacerRef.current || !containerRef.current) {
			return;
		}

		const topNavBottomPosition = topNavBottomPositionRef.current;
		const containerBoudingRect = containerRef.current.getBoundingClientRect();
		const spacerPageY = containerBoudingRect.top + window.scrollY;

		const height = Math.max(
			0,
			Math.min(0, window.scrollY - spacerPageY) + topNavBottomPosition,
		);

		spacerRef.current.style.height = `${height}px`;
	});

	const updateTopNavBottomPosition = useEventCallback((position: number) => {
		topNavBottomPositionRef.current = position;

		update();
	});

	useEffect(() => {
		subscribeToTopNavBottomPosition(updateTopNavBottomPosition);

		return () => {
			unsubscribeFromTopNavBottomPosition(updateTopNavBottomPosition);
		};
	}, [updateTopNavBottomPosition]);

	useEffect(() => {
		update();
	}, [update]);

	useEffect(() => {
		window.addEventListener('scroll', update);

		return () => {
			window.removeEventListener('scroll', update);
		};
	}, [update]);

	useElementBoudingClientRectUpdated(containerRef.current, update);

	return <div ref={spacerRef} />;
};

export default SVTopNavSpacer;
